import { Group, InputElement } from "@chakra-ui/react";
import { cloneElement, forwardRef } from "react";

export const InputGroup = forwardRef(
  /**
   * @typedef {object} Props
   * @prop {React.ReactNode} [startElement]
   * @prop {Record<string, any>} [startElementProps]
   * @prop {React.ReactNode} [endElement]
   * @prop {Record<string, any>} [endElementProps]
   * @prop {import("react").ReactElement} children
   */
  /**
   * @param {Props & import("@chakra-ui/react").GroupProps} props
   */
  function InputGroup(props, ref) {
    const {
      startElement,
      startElementProps,
      endElement,
      endElementProps,
      children,
      ...rest
    } = props;

    return (
      <Group ref={ref} {...rest}>
        {startElement && (
          <InputElement pointerEvents="none" {...startElementProps}>
            {startElement}
          </InputElement>
        )}

        {cloneElement(children, {
          ...(startElement && { ps: "calc(var(--input-height) - 6px)" }),
          ...(endElement && { pe: "calc(var(--input-height) - 6px)" }),
          ...children.props,
        })}

        {endElement && (
          <InputElement placement="end" {...endElementProps}>
            {endElement}
          </InputElement>
        )}
      </Group>
    );
  },
);
